import React from 'react';

import { Button } from 'antd';

import { CaretRightOutlined, CaretLeftOutlined } from '@ant-design/icons';

const CollapseBtn = (props) => {
  const { isTable, collapse, mainMenuCollapse } = props;

  const onClickHandler = () => {
    mainMenuCollapse(!collapse);
  };

  return isTable ? null : (
    <Button
      onClick={onClickHandler}
      className={collapse ? 'collapse_btn collapse' : 'collapse_btn'}
    >
      {collapse ? <CaretRightOutlined /> : <CaretLeftOutlined />}
    </Button>
  );
};

export default CollapseBtn;
